import _ from 'lodash';
import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';
const { getStringsForPage } = contentfulModels;
import CreateAccount from 'app/components/account/create';
import { fetchCreateAccountPage, createAccount } from 'app/api/account-api';

const mapStateToProps = state => ({
  success: _.get(state, 'account.createAccount.success'),
  userAlreadyExistsError: _.get(state, 'account.createAccount.error.userAlreadyExists'),
  unacceptableEmailError: _.get(state, 'account.createAccount.error.unacceptableEmail'),
  genericError: _.get(state, 'account.createAccount.error.generic'),
  pageStrings: getStringsForPage(_.get(state, 'account.createAccountPage')),
});

const mapDispatchToProps = dispatch => ({
  onSubmit: values => dispatch(createAccount(values)),
});

const hasCreateAccountContent = dispatch => dispatch(fetchCreateAccountPage());

const CreateAccountContainer = connect(mapStateToProps, mapDispatchToProps)(preload(
  ({ dispatch }) => hasCreateAccountContent(dispatch))(CreateAccount),
);

export default CreateAccountContainer;



// WEBPACK FOOTER //
// ./app/containers/account/create.js